import { Component, inject, OnInit } from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import {
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  FormBuilder,
} from '@angular/forms';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { SearchBarComponent } from '@app/shared/components/search-bar/search-bar.component';
import { CardEmpresa03Component } from '../home-empresas/card-empresa-03/card-empresa-03.component';
import { PaginatorControlComponent } from '@app/shared/components/paginator-control/paginator-control.component';
import { ApiService } from '@core/providers/http';
import {
  Empresa,
  EmpresaService,
  TipoEmpresaService,
} from '@app/features-modules/bolsa-de-profissionais/api';
import { CadastrarEmpresaComponent } from '../cadastrar-empresa/cadastrar-empresa.component';
import { FilterItem } from '../../../../gestao-bolseiros/components/api/models/filterItem.model';
import { Pagination } from '@app/shared/model';
import { TesteService } from '@app/shared/services/teste.service';
import { EmpresaSectorService } from '@app/features-modules/bolsa-de-profissionais/services/empresa-sector.service';
import { DataVoidComponent } from '@app/shared/components/data-void/data-void.component';
import { DialogModule } from 'primeng/dialog';
import { SelectModule } from 'primeng/select';
import { Button } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { BackButtonComponent } from '@app/shared/components/back-button/back-button.component';
import { AuthStore } from '@core/service/auth-store.service';

@Component({
  selector: 'app-home-empresas',
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    ToastModule,
    SearchBarComponent,
    CardEmpresa03Component,
    PaginatorControlComponent,
    DataVoidComponent,
    DialogModule,
    SelectModule,
    Button,
    InputTextModule,
    BackButtonComponent,
  ],
  providers: [
    DialogService,
    ApiService,
    EmpresaSectorService,
    TipoEmpresaService,
    MessageService,
  ],
  templateUrl: './home-empresas.component.html',
  styleUrls: ['./home-empresas.component.scss'],
  standalone: true,
})
export class HomeEmpresasComponent implements OnInit {
  private router = inject(Router);
  route = inject(ActivatedRoute);
  private auth = inject(AuthStore);
  dialogService = inject(DialogService);
  tipoEmpresaService = inject(TipoEmpresaService);
  empresaService = inject(EmpresaSectorService);
  messageService = inject(MessageService);

  constructor(
    public fb: FormBuilder,
    private sharedService: TesteService,
  ) {}

  pagination: Pagination<any> = new Pagination<any>();
  empresaSectorList: Empresa[] = [];
  listaEmpresas: any[] = [];
  isLoading: boolean = false;
  form!: FormGroup;
  empresaCount: any;

  imagePreviewMap: { [id: number]: string | ArrayBuffer | null } = {};

  subSectorOptions: any[] = [
    {
      id: 1,
      designacao: 'Petróleo e Gás',
    },
    {
      id: 2,
      designacao: 'Recursos Minerais',
    },
  ];

  tipoEmpresas: any[] = [
    {
      id: 1,
      designacao: 'Empresa do sector',
    },
    {
      id: 2,
      designacao: 'Manpower',
    },
  ];

  estadoOptions: any[] = [
    {
      id: 1,
      designacao: 'Activo',
    },
    {
      id: 2,
      designacao: 'Desactivado',
    },
  ];

  CapitalOptions: any[] = [
    {
      id: 1,
      designacao: 'Nacional',
    },
    {
      id: 2,
      designacao: 'Estrangeiro',
    },
  ];

  filters: FilterItem[] = [
    {
      type: 'dropdown',
      controlName: 'SubSector',
      placeholder: 'SubSector',
      options: this.subSectorOptions,
      optionLabel: 'designacao',
      optionValue: 'id',
    },
    {
      type: 'dropdown',
      controlName: 'TipoEmpresa',
      placeholder: 'Tipo de empresa',
      options: this.tipoEmpresas,
      optionLabel: 'designacao',
      optionValue: 'id',
    },
    { type: 'text', controlName: 'nIF', placeholder: 'NIF da empresa' },
    {
      type: 'dropdown',
      controlName: 'EmpresaID',
      placeholder: 'Empresa',
      options: this.listaEmpresas,
      optionLabel: 'nome',
      optionValue: 'id',
    },
    {
      type: 'dropdown',
      controlName: 'Capital',
      placeholder: 'Capital',
      options: this.CapitalOptions,
      optionLabel: 'designacao',
      optionValue: 'id',
    },

    {
      type: 'dropdown',
      controlName: 'Estado',
      placeholder: 'Estado',
      options: this.estadoOptions,
      optionLabel: 'designacao',
      optionValue: 'id',
    },
  ];

  imagePreview: string | ArrayBuffer | null = null; // To store image as Base64 URL

  ngOnInit() {
    // this.getAllTipoEmpresa();
    this.getAllEmpresas();
    this.getAllEmpresasName();
    this.sharedService.showEmpresas$.subscribe((value) => {
      this.ShowEmpresas = value;
    });

    this.form = this.fb.group({
      nIF: [null],
      TipoEmpresa: [null],
      SubSector: [null],
      EmpresaID: [null],
      Estado: [null],
      Capital: [null],
    });
  }

  getAllEmpresasName(filters?: any) {
    const params = {
      pageNumber: 1,
      pageSize: 100,
      ...filters,
    };
    this.empresaService.list(params).subscribe(
      (res: any) => {
        this.listaEmpresas = res.data;
        this.filters[3].options = this.listaEmpresas;
      },
      (error: any) => {
        console.error('Erro ao buscar empresas:', error);
      },
    );
  }

  ShowEmpresas: boolean = false;

  // getAllTipoEmpresa() {
  //   this.tipoEmpresaService.getAllTipoEmpresaGet().subscribe(
  //     (res: any) => {
  //       this.tipoEmpresas = res.data;
  //       this.filters = [
  //         {
  //           type: 'text',
  //           controlName: 'Nome',
  //           placeholder: 'Pesquise pela empresa',
  //         },
  //         {
  //           type: 'dropdown',
  //           controlName: 'TipoEmpresa',
  //           placeholder: 'Tipo de empresa',
  //           options: this.tipoEmpresas,
  //           optionLabel: 'designacao',
  //           optionValue: 'id',
  //         },
  //       ];
  //     },
  //     (error: any) => {
  //       console.error('Erro ao buscar tipos de empresa:', error);
  //     }
  //   );
  // }

  getAllEmpresas(filters?: any) {
    this.isLoading = true;
    const params = {
      pageNumber: this.pagination.pageNumber ?? 1,
      pageSize: this.pagination.pageSize ?? 10,
      OrderBy: filters?.OrderBy || 'id desc',
      ...filters,
    };
    this.empresaService.list(params).subscribe(
      (res: any) => {
        this.empresaSectorList = res.data;
        this.pagination = new Pagination<any>().deserialize(res);
        this.empresaCount = this.pagination?.totalRecords;
        this.isLoading = false;
        this.empresaSectorList.forEach((emp) => {
          this.getPhotoByEmpresaId(emp.id);
        });
      },
      (error: any) => {
        console.error('Erro ao buscar empresas:', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Erro',
          detail: 'Erro ao buscar empresas.',
          life: 3000,
        });
        this.isLoading = false;
      },
    );
  }

  onPageChange(event: any) {
    this.pagination.pageNumber = event.page + 1;
    this.pagination.pageSize = event.rows;
    this.getAllEmpresas();
  }

  onFilterChange(filters: any) {
    this.getAllEmpresas(filters);
  }

  getPhotoByEmpresaId(id: number): void {
    this.empresaService.getPhotoEmpresaIdGet(id).subscribe({
      next: (response) => {
        if (!response || !response.type.startsWith('image/')) {
          console.warn('Resposta não é imagem. A usar placeholder.');
          this.imagePreviewMap[id] = null;
          return;
        }
        const reader = new FileReader();
        reader.onload = () => {
          this.imagePreviewMap[id] = reader.result;
        };
        reader.readAsDataURL(response);
      },
      error: (err) => {
        console.error(`Erro ao carregar imagem da empresa ${id}:`, err);
        this.imagePreviewMap[id] = null;
      },
    });
  }

  showDialog() {
    if (this.auth.hasAny(['Registar_Empresa_Sector'])) {
      const ref = this.dialogService.open(CadastrarEmpresaComponent, {
        showHeader: false,
        width: '45%',
        modal: true,
        data: {
          tipoEmpresas: this.tipoEmpresas,
        },
      });

      ref.onClose.subscribe((data) => {
        if (data instanceof FormData) {
          this.isLoading = true;
          this.empresaService.storeWithLogo(data).subscribe(
            (response: any) => {
              this.getAllEmpresas();
              this.messageService.add({
                severity: 'success',
                summary: 'Sucesso',
                detail: 'Empresa criada com sucesso!',
                life: 3000,
              });
              this.isLoading = false;
              // Wait 2 seconds before redirecting
              setTimeout(() => {
                this.router.navigate([`/bolsa-profissionais/empresas`]);
              }, 2000);
            },
            (error: any) => {
              console.error('Erro ao criar empresa:', error);
              this.messageService.add({
                severity: 'error',
                summary: 'Erro',
                detail: 'Erro ao criar empresa.',
                life: 3000,
              });
              this.isLoading = false;
            },
          );
        }
      });
    } else {
      this.messageService.add({
        severity: 'error',
        summary: 'Permissão Inválida',
        detail: 'Não tens permissão para efetuar esta acção',
        life: 3000,
      });
    }
  }

  trackById(index: number, item: any) {
    return item.id;
  }

  showFilter = false;

  showFilterModal() {
    this.showFilter = true;
  }

  handleFormValueChange(event: any) {
    const filters = Object.fromEntries(
      Object.entries(event).filter(
        ([_, value]) => value !== null && value !== undefined && value !== '',
      ),
    );
    this.getAllEmpresas(filters);
    this.showFilter = false;
  }
}
